<template>
  <div>
    <div style="width: 1300px; margin: 0 auto; display: flex; flex-direction: column; gap: 20px;">
      
      <!-- Top Card: Two Pies -->
      <el-card shadow="always" style="border-radius: 12px; border: none;">
        <div style="display: flex; justify-content: space-around; align-items: center; width: 100%;">
          <div style="flex: 1; display: flex; justify-content: center;"><GenomesPie /></div>
          <div style="flex: 1; display: flex; justify-content: center;"><GenesPie /></div>
        </div>
      </el-card>

      <!-- Bottom Card: Interactive Selection -->
      <el-card shadow="always" style="border-radius: 12px; border: none;">
        
        <!-- Search Tags -->
        <div style="width: 100%; display: flex; gap: 40px; margin-bottom: 20px;">
          <div class="search_box_dynamic">
            <div style="background-color: #ecf5ff; border-left: 4px solid #409eff; color: #606266; padding: 12px 16px; border-radius: 4px; margin-bottom: 15px; font-size: 14px; display: flex; align-items: center;">
              <i class="el-icon-info" style="color: #409eff; margin-right: 10px; font-size: 18px;"></i>
              <div>
                <strong>1.</strong> Choose a taxon by selecting from the tree.
              </div>
            </div>
            <div>
            <el-tag
              v-for="(item, index) in genomeList"
              :key="index"
              :disable-transitions="false"
              closable
              @close="handleGenomeClose(index, item)"
              style="margin: 4px;"
            >
              {{ item.tag }}
            </el-tag></div>
          </div>
          <div class="search_box_dynamic">
            <div style="background-color: #ecf5ff; border-left: 4px solid #409eff; color: #606266; padding: 12px 16px; border-radius: 4px; margin-bottom: 15px; font-size: 14px; display: flex; align-items: center;">
              <i class="el-icon-info" style="color: #409eff; margin-right: 10px; font-size: 18px;"></i>
              <div>
                <strong>2.</strong> Choose a gene by selecting from the tree.
              </div>
            </div>
            <div>
            <el-tag
              v-for="(item, index) in geneList"
              :key="index"
              :disable-transitions="false"
              closable
              @close="handleGeneClose(index, item)"
              style="margin: 4px;"
            >
              {{ item.tag }}
            </el-tag></div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div style="display: flex; margin-bottom: 20px; gap: 15px;">
          <el-button type="info" @click="clear" plain>
            Clear
          </el-button>
          <el-button type="primary" @click="downHeatMap">
            Draw heatmap
          </el-button>
          <el-button type="warning" @click="search">
            Get information and sequence
          </el-button>
          <el-button type="success" @click="constructPhyloTree">
            Phylogenetic analysis
          </el-button>
        </div>

        <!-- Trees -->
        <div style="display: flex; gap: 40px;">
          <div class="tree-container">
            
            <div class="title">
              <svg
                t="1728461381723"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="1701"
                width="20"
                height="20"
              >
                <path
                  d="M845.567023 493.120024c63.231921 0 114.431857-50.943936 114.431857-113.919858 0-62.847921-51.199936-113.727858-114.431857-113.727858a113.983858 113.983858 0 0 0-113.727858 125.503843l-24.703969 11.967985a157.247803 157.247803 0 0 0-161.215798-62.783921l-17.791978-46.527942A160.639799 160.639799 0 0 0 597.759333 161.216438 161.599798 161.599798 0 0 0 435.839535 0.00064a161.599798 161.599798 0 0 0-162.047797 161.215798A161.599798 161.599798 0 0 0 464.639499 319.74424l18.815977 49.087939a155.903805 155.903805 0 0 0-55.679931 168.447789l-32.959959 15.871981a181.119774 181.119774 0 0 0-149.759812-78.975902A180.607774 180.607774 0 0 0 64 654.335822a180.671774 180.671774 0 0 0 181.119774 180.159775 180.671774 180.671774 0 0 0 180.991773-180.159775c0-13.183984-1.535998-26.047967-4.223994-38.527952l39.295951-18.943976a156.991804 156.991804 0 0 0 129.535838 52.031935l37.119953 96.959879a151.167811 151.167811 0 0 0-68.223915 126.399842A152.12781 152.12781 0 0 0 712.12719 1023.99936a152.12781 152.12781 0 0 0 152.447809-151.74381 152.12781 152.12781 0 0 0-172.351784-150.271812l-35.711956-93.183884A156.287805 156.287805 0 0 0 735.99916 492.928024c0-9.279988-0.959999-18.239977-2.495997-27.007966l25.791968-12.351985c20.863974 24.19197 51.839935 39.551951 86.271892 39.551951z m0-159.359801c25.215968 0 45.759943 20.351975 45.759943 45.439943 0 25.151969-20.479974 45.567943-45.759943 45.567943a45.631943 45.631943 0 0 1-45.759943-45.503943c0-25.151969 20.607974-45.503943 45.759943-45.503943z m-600.511249 432.447459a112.38386 112.38386 0 0 1-112.44786-111.87186c0-61.695923 50.495937-111.93586 112.44786-111.93586 61.951923 0 112.447859 50.239937 112.447859 111.93586 0 61.631923-50.367937 111.87186-112.447859 111.87186zM435.839535 254.080322c-51.583936 0-93.439883-41.727948-93.439883-92.991883 0-51.199936 41.855948-92.927884 93.439883-92.927884 51.519936 0 93.439883 41.663948 93.439883 92.927884 0 51.263936-41.919948 92.991884-93.439883 92.991883z m276.479655 534.911332a83.839895 83.839895 0 0 1 83.839895 83.455895 83.839895 83.839895 0 0 1-83.839895 83.519896 83.839895 83.839895 0 0 1-83.967895-83.519896 83.839895 83.839895 0 0 1 83.903895-83.455895zM578.687357 581.311913a88.511889 88.511889 0 0 1-88.703889-88.191889c0-48.703939 39.74395-88.25589 88.703889-88.25589 48.895939 0 88.639889 39.551951 88.639889 88.25589 0 48.639939-39.80795 88.19189-88.639889 88.191889z"
                  p-id="1702"
                  fill="#1ba524"
                ></path>
              </svg>
              <span>Taxon</span>
            </div>

            <el-tree
              ref="tree"
              :props="props"
              :load="loadGenomeNode"
              lazy
              node-key="id"
              highlight-current
              @node-click="handleNodeClickGenome"
              :expand-on-click-node="false"
            >
              <span class="custom-tree-node" slot-scope="{ node }">
                <span v-if="node.level == 6">
                  <el-checkbox
                    v-model="node.checked"
                    v-if="!checkedMax || node.checked"
                    @change="handleChecked(node, node.checked, node.label)"
                    >{{ node.label }}</el-checkbox
                  >
                  <el-checkbox
                    v-model="node.checked"
                    v-else
                    disabled
                    >{{ node.label }}</el-checkbox
                  >
                </span>
                <span v-if="node.level != 6">
                  {{ node.label }}
                </span>
              </span>
            </el-tree>
          
          </div>
          <div class="tree-container">
            
            <div class="title">
              <svg
                t="1728461538576"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6980"
                width="20"
                height="20"
              >
                <path
                  d="M938.666667 213.333333h-128V85.333333h-85.333334v128h-85.333333a170.666667 170.666667 0 0 0-170.666667 170.666667v85.333333h-85.333333a170.666667 170.666667 0 0 0-170.666667 170.666667v85.333333H85.333333v85.333334h128v128h85.333334v-128h85.333333a170.666667 170.666667 0 0 0 170.666667-170.666667v-85.333333h85.333333a170.666667 170.666667 0 0 0 170.666667-170.666667v-85.333333h128zM469.333333 640a85.333333 85.333333 0 0 1-85.333333 85.333333h-85.333333v-85.333333a85.333333 85.333333 0 0 1 85.333333-85.333333h85.333333z m256-256a85.333333 85.333333 0 0 1-85.333333 85.333333h-85.333333v-85.333333a85.333333 85.333333 0 0 1 85.333333-85.333333h85.333333z"
                  p-id="6981"
                  fill="#1b8822"
                ></path>
              </svg>
              <span>Gene</span>
            </div>

            <el-tree
              ref="tree2"
              :props="props"
              :load="loadGeneNode"
              lazy
              node-key="id"
              highlight-current
              :expand-on-click-node="false"
            >
              <span class="custom-tree-node" slot-scope="{ node }"
                ><span v-if="node.level != 2">{{ node.label }}</span>
                <span v-if="node.level == 2">
                  <el-checkbox
                    v-model="node.checked"
                    @change="handleCheckedGene(node, node.checked, node.label)"
                    >{{ node.label }}</el-checkbox
                  >
                </span>
              </span>
            </el-tree>
          
          </div>
        </div>

      </el-card>
    </div>
  </div>
</template>

<script>
import GenomesPie from "../components/GenomesPie.vue";
import GenesPie from "../components/GenesPie.vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Genes",
  components: { GenomesPie, GenesPie },
  data() {
    return {
      searchQuerry: [],
      userInput1: "",
      userInput2: "",
      layerNum1: 0,
      layerNum2: 0,
      // 名称替换映射表
      nameMap: {
        Phycophyta: "Algae",
        Angiosperm: "Angiosperms",
        Gymnosperm: "Gymnosperms",
        Bryophyte: "Bryophytes",
        Pteridophyte: "Pteridophytes",
      },
      props: {
        //用于tree
        label: "name",
        isLeaf: "leaf",
      },
      idGene: 0,
      idGenome: 0,
      showBox: true,
      genomeList: [],
      geneList: [],
      geneMax: false,
      geneName: "",
      genomeTags: [],
      geneTags: [],
    };
  },
  methods: {
    // 名称替换方法：如果 name 在 nameMap 中则替换，否则原样返回
    replaceName(name) {
      return this.nameMap[name] || name;
    },
    search() {
      //跳转tree搜索结果页面
      if (this.genomeList.length < 1) {
        this.$message.warning("Please choose at least one species.");
        return;
      }
      if (this.genomeList.length > 15) {
        this.$message.warning("Please select no more than 15 species.");
        return;
      }
      if (this.geneList.length < 1) {
        this.$message.warning("Please choose at least one gene.");
        return;
      }
      {
        // 保存对象到 sessionStorage
        sessionStorage.setItem("value1", this.value1);
        sessionStorage.setItem("value2", this.value2);
        this.$router.push({ path: "/TreeResult" });
      }
    },
    async loadGeneNode(node, resolve) {
      let arr = [];

      if (node.level === 0) {
        try {
          // 调用获取信息的api请求 , 并解构出data, 重命名为res
          const { data: res } = await this.$axios.get("/api/api.genes/tree");
          for (var i = 0; i < res.data.length; i++) {
            arr.push({ id: this.idGene++, name: res.data[i] });
          }
          // 赋值
          return resolve(arr);
        } catch (err) {
          console.log(err);
        }
      } else if (node.level === 1) {
        const { data: res } = await this.$axios.get("/api/api.genes/tree", {
          params: { genesGroup: node.data.name },
        });
        // eslint-disable-next-line no-redeclare
        for (var i = 0; i < res.data.length; i++) {
          arr.push({ id: this.idGene++, name: res.data[i], leaf: true });
        }
      }
      setTimeout(() => {
        resolve(arr);
      }, 100);
    },
    async loadGenomeNode(node, resolve) {
      let arr = [];

      if (node.level === 0) {
        try {
          // 调用获取信息的api请求 , 并解构出data, 重命名为res
          const { data: res } = await this.$axios.get("/api/api.genomes/tree");
          for (var i = 0; i < res.data.length; i++) {
            const displayName = this.replaceName(res.data[i]);
            arr.push({
              id: this.idGenome++,
              name: displayName,
              label: displayName,
              value: res.data[i],
              checked: false,
            });
          }
          console.log(res);
          // 赋值
          return resolve(arr);
        } catch (err) {
          console.log(err);
        }
      } else if (node.level > 0 && node.level < 6) {
        const { data: res } = await this.$axios.get("/api/api.genomes/tree", {
          params: { parentKey: node.level - 1, parentValue: node.data.value || node.data.name },
        });
        if (node.level < 5) {
          // eslint-disable-next-line no-redeclare
          for (var i = 0; i < res.data.length; i++) {
            const originalVal = res.data[i];
            const displayName = this.replaceName(originalVal);
            arr.push({
              id: this.idGenome++,
              name: displayName,
              value: originalVal,
            });
          }
        } else {
          // eslint-disable-next-line no-redeclare
          for (var i = 0; i < res.data.length; i++) {
            const displayName = this.replaceName(res.data[i]);
            arr.push({
              id: this.idGenome++,
              name: displayName,
              leaf: true,
              label: displayName,
              value: res.data[i],
              checked: false,
            });
          }
        }
      }
      if (node.data.id == 0 || node.data.id == 6) {
        return resolve(arr);
      } else {
        setTimeout(() => {
          resolve(arr);
        }, 100);
      }
    },
    handleNodeClickGenome(data) {
      this.currentGenome = data.name;
    },

    handleChecked(node, checked, label) {
      if (checked) {
        this.genomeList.push({ id: node.key, tag: label, value: node.data.value || node.data.name });
      } else {
        const index = this.genomeList.findIndex(
          (item) => item.id === node.key && item.tag === label
        );
        if (index !== -1) {
          this.genomeList.splice(index, 1);
        }
      }
    },
    handleCheckedGene(node, checked, label) {
      if (checked) {
        this.geneList.push({ id: node.key, tag: label });
      } else {
        const index = this.geneList.findIndex(
          (item) => item.id === node.key && item.tag === label
        );
        if (index !== -1) {
          this.geneList.splice(index, 1);
        }
      }
    },
    handleGenomeClose(index, item) {
      this.genomeList.splice(index, 1);
      this.$nextTick(() => {
        const node = this.$refs.tree.getNode(item.id);
        if (node) {
          node.checked = false;
        }
      });
    },
    handleGeneClose(index, item) {
      this.geneList.splice(index, 1);
      this.$nextTick(() => {
        const node = this.$refs.tree2.getNode(item.id);
        if (node) {
          node.checked = false;
        }
      });
      this.geneMax = false;
    },
    clear() {
      this.genomeList = [];
      this.geneList = [];
      this.$refs.tree.setCheckedKeys([]);
      this.$refs.tree2.setCheckedKeys([]);
    },
    async constructPhyloTree() {
      if (!this.genomeList || this.genomeList.length < 3) {
        this.$message.warning("Please select at least 3 Taxon groups to construct a phylogenetic tree.");
        return;
      }
      if (this.genomeList.length > 15) {
        this.$message.warning("Please select no more than 15 Taxon groups to construct a phylogenetic tree.");
        return;
      }
      if (!this.geneList || this.geneList.length < 1) {
        this.$message.warning("Please choose at least one gene.");
        return;
      }
      
      const loading = this.$loading({
        lock: true,
        text: 'Constructing phylogenetic tree...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let taxonsArray = this.genomeList.map(item => item.value || item.tag);
      let genesArray = this.geneList ? this.geneList.map(item => item.tag) : [];

      try {
        const { data: res } = await this.$axios.post("api/api.genomes/phylotree", {
          taxons: taxonsArray,
          genes: genesArray
        });
        
        if (res && res.code === 202) {
          const taskId = res.task_id;
          loading.text = 'Task queued. Waiting for execution...';
          
          const pollInterval = setInterval(async () => {
            try {
              const { data: statusRes } = await this.$axios.get(`api/api.genomes/phylotree_status/${taskId}`);
              const statusData = statusRes.data;
              
              if (statusData.state === 'PENDING') {
                loading.text = 'Queued in background...';
              } else if (statusData.state === 'SUCCESS') {
                clearInterval(pollInterval);
                loading.close();
                
                const finalRes = statusData.result;
                if (finalRes && finalRes.code === 200) {
                  const treeData = finalRes.data; 
                  sessionStorage.setItem('treeData', typeof treeData === 'string' ? treeData : JSON.stringify(treeData));
                  
                  this.$router.push({
                    name: "PhylogeneticTree",
                    params: {
                      data: treeData,
                    },
                  });
                } else {
                  this.$message.error(finalRes.message || "Failed to construct phylogenetic tree.");
                }
              } else if (statusData.state === 'FAILURE') {
                clearInterval(pollInterval);
                loading.close();
                this.$message.error("Task failed: " + statusData.status);
              } else {
                loading.text = 'Constructing phylogenetic tree...';
              }
            } catch (pollErr) {
              console.error(pollErr);
            }
          }, 3000); // Poll every 3 seconds

        } else {
          loading.close();
          this.$message.error(res ? res.message : "Failed to submit task to server.");
        }
      } catch (error) {
        loading.close();
        console.error("Error constructing tree:", error);
        this.$message.error("An error occurred while submitting the task.");
      }
    },
    async downHeatMap() {
      var that = this;
      if (this.genomeList.length < 1) {
        this.$message.warning("Please choose at least one species.");
        return;
      }
      if (this.genomeList.length > 15) {
        this.$message.warning("Please select no more than 15 species for Heatmap.");
        return;
      }
      if (this.geneList.length < 1) {
        this.$message.warning("Please choose at least one gene.");
        return;
      }
      {
        var { data: res } = await this.$axios.get("/api/api.tree/result", {
          params: {
            genomesTreeList: this.value1,
            genesTreeList: this.value2,
            pageSize: 1000,
          },
          paramsSerializer: function (params) {
            return that.$qs.stringify(params, { arrayFormat: "repeat" });
          },
        });
        console.log(res);
        if (res.data.count > 1000) {
          //获取全部信息，如果信息条数大于1000再重新获取
          const { data: res2 } = await this.$axios.get("/api/api.tree/result", {
            params: {
              genomesTreeList: this.value1,
              genesTreeList: this.value2,
              pageSize: res.data.count,
            },
            paramsSerializer: function (params) {
              return that.$qs.stringify(params, { arrayFormat: "repeat" });
            },
          });
          res = res2;
        }
        const speciesGenesCount = new Map();
        const assemblyCast = new Map();
        // 遍历resData中的每条信息
        res.data.rows.forEach((item) => {
          const { geneName, organismName, assembly } = item;

          // 如果speciesGenesCount中没有当前物种的记录，就创建一个新的Map
          if (!speciesGenesCount.has(assembly)) {
            speciesGenesCount.set(assembly, new Map());
            assemblyCast.set(assembly, organismName);
          }

          // 获取当前物种的基因计数Map
          const geneCountMap = speciesGenesCount.get(assembly);

          // 如果基因计数Map中没有当前基因的记录，就初始化计数为0
          if (!geneCountMap.has(geneName)) {
            geneCountMap.set(geneName, 0);
          }

          // 增加当前基因的计数
          geneCountMap.set(geneName, geneCountMap.get(geneName) + 1);
        });
        console.log(assemblyCast);
        // 将Map转换为普通对象以便在模板中使用
        const speciesGenesCountObj = {};
        speciesGenesCount.forEach((geneCountMap, species) => {
          speciesGenesCountObj[species] = Object.fromEntries(geneCountMap);
        });

        console.log(speciesGenesCountObj);
        const keys = Object.keys(speciesGenesCountObj);
        const genes = Object.keys(speciesGenesCountObj[keys[0]]).sort();
        console.log(keys);
        console.log(genes);
        // 添加标题行
        var data = "Species,";
        keys.forEach((item) => {
          data += assemblyCast.get(item) + `(${item}),`;
        });
        data = data.slice(0, -1);
        data += "\n";
        // 添加数据行
        for (const gene of genes) {
          const row = keys
            .map((key) => speciesGenesCountObj[key][gene] || 0)
            .join(",");
          data += `${gene},${row}\n`;
        }
        data = data.slice(0, -1);
        
        sessionStorage.setItem("heatMapCsvData", data);
        this.$router.push({ name: 'HeatMapTool' });
      }
    },
  },
  computed: {
    checkedMax() {
      return this.genomeList.length >= 15;
    },
    value1() {
      return this.genomeList.map((item) => item.value || item.tag);
    },
    value2() {
      return this.geneList.map((item) => item.tag);
    },
  },
};
</script>

<style scoped>
.search_box_dynamic { flex: 1; min-height: 50px; }

.tree-container { flex: 1; overflow: auto; padding: 10px; border: 1px solid #ebeef5; border-radius: 8px; }


.title {
  margin: 10px;

  border-bottom: 2px solid grey;
}
.title span {
  font-size: 20px;
  font-weight: 600;
  color: green;
  font-family: "Times New Roman", Times, serif;
}
.title svg {
  margin: 0 5px;
}
el-tag {
  margin-bottom: 10px; /* 为 el-tag 添加底部边距 */
}
.twoPies {
  margin-top:30px ;
  width: 570px;
}
</style>